import BaseService from './BaseService';

class StaticDataService extends BaseService {
    getStaticData = () => this.get('/static-data');
}

export default new StaticDataService();
